import React from 'react';
import { useUrlFriendlyToParameters, useGetURL } from "helpers/urlFriendly";
import { useGetDisciplines } from 'helpers/commonCodes';
import { Link } from 'react-router-dom';
import { useGetFunctionOCSUrl } from 'helpers/utils';

export const Discipline = ({ code, description, showDescription = true, hasLink, className }) => {
    const params = useUrlFriendlyToParameters()
    const getOCSURL = useGetFunctionOCSUrl()

    const paramsURL = { ...params }
    const getURL = useGetURL()
    const allDisciplines = useGetDisciplines(params);
    let disciplineDescrip = allDisciplines?.disciplines?.find(row => row?.code === code)?.description
    description = description ? description : disciplineDescrip;

    paramsURL["mirs_discipline"] = code
    let url = getURL(paramsURL, "schedule")
    url = getOCSURL(url, "schedule", paramsURL)

    let Sprites = require(`styles/${params.mirs_competition}/images/SpritePictosBig.svg`);

    return (
        <>
            <div className='discipline-sport'>
                {hasLink ? (
                    <Link to={url} style={{ textDecoration: 'none' }}>
                        <div className="sport-icon " >
                            <svg role="img" className='sport-icon' aria-hidden={showDescription ? true : false} focusable="false"> <title>{description}</title><use xlinkHref={`${Sprites}#${code}`} /></svg>
                        </div>
                        {/*  <div className={`sport-icon ${code}`} alt={code}></div>*/}
                        {showDescription && <span className='text-start'>{description}</span>}
                    </Link>
                ) : (
                    <>
                        <div className="sport-icon " >
                            <svg role="img" className='sport-icon' aria-hidden={showDescription ? true : false} focusable="false"> <title>{description}</title><use xlinkHref={`${Sprites}#${code}`} /></svg>
                        </div>
                        {/* showDescription && <span>{description}</span> */}
                        {<span className='text-start'>{description}</span>}
                    </>
                )}
            </div>
        </>
    )
};

export const DisciplineMemo = React.memo(Discipline);

export default Discipline;
